declare global {
  interface Window {
    ReactNativeWebView?: { postMessage: (message: string) => void };
  }
}

const postWebViewMessage = (type: string, data: Record<string, unknown> = {}): void => {
  window.ReactNativeWebView?.postMessage(JSON.stringify({
    type,
    ...data,
  }));
};

const appNavigate = (tab: string, params: Record<string, unknown> = {}): void => {
  postWebViewMessage('navigate', { tab, params });
};

interface LoginStatus {
  isLoggedIn: boolean;
  username?: string;
  logo?: string;
  hasInterventionPointTab?: boolean;
  email?: string;
  role?: string;
  canCreateRequests?: boolean;
}

const postLoginStatus = ({ isLoggedIn, username, logo, hasInterventionPointTab, email, role, canCreateRequests }: LoginStatus): void => {
  postWebViewMessage('loggedIn', { isLoggedIn, username, logo, hasInterventionPointTab, email, role, canCreateRequests });
};

export { appNavigate, postWebViewMessage, postLoginStatus };
